<template>
  <div class="image-swiper flex flex-row items-center md:mt-3x sm:mt-3x">
    <div v-if="images.length > 1" class="icon outline image-swiper-prev hide-sm">
      <icon name="chevron-left" scale="1.25"></icon>
    </div>
    <swiper :options="imageSwiperOptions" ref="imageSwiper">
      <swiper-slide v-for="img in images" :key="Math.random().toString(36).substr(2, 9)">
        <img-comp :element="img" :size="size" :alt="img.name"></img-comp>
      </swiper-slide>
    </swiper>
    <div v-if="images.length > 1" class="icon outline image-swiper-next hide-sm">
      <icon name="chevron-right" scale="1.25"></icon>
    </div>
  </div>
</template>

<script>
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'imageSlider',
    props: {
      images: {
        type: Array
      },
      size: {
        type: String,
        default: 'l'
      }
    },
    mixins: [helpers, formatting],
    created () {
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.handleResize)
    },
    data () {
      return {
        imageSwiperOptions: {
          loop: true,
          slidesPerView: 1,
          centeredSlides: true,
          pagination: {
            el: '.image-swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.image-swiper-next',
            prevEl: '.image-swiper-prev'
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/slider/imageSlider.vue